import {
  useState, ReactNode,
} from 'react';
import { useApi } from 'lib/contexts/ApplicationState';
import { useSnackbar } from 'notistack';
import { FileUploadDragDrop, resumeUploadFn } from 'components/FileUpload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

interface Props {
  title?: ReactNode;
  onUpload: (arg: string) => void;
  miniMode?: boolean;
  text?: string;
}

export const ResumeUpload = ({
  title,
  onUpload,
  miniMode = false,
  text = 'Click to upload your resume',
}: Props) => {
  const [resumeUrl, setResumeUrl] = useState<string>();

  const { enqueueSnackbar } = useSnackbar();

  const API = useApi();

  const saveResume = async (resumeUrls: string[]) => {
    try {
      const firstResume = resumeUrls[0];
      onUpload(firstResume);
      setResumeUrl(firstResume);
      enqueueSnackbar('Your resume has been uploaded', { variant: 'success' });
    } catch (err) {
      enqueueSnackbar(`Error saving resume ${err}`, { variant: 'error' });
    }
  };

  const renderResume = () => {
    if (resumeUrl) {
      return (
        <div className="flex items-center space-x-2">
          <span>
            <PictureAsPdfIcon />
          </span>

          <span>
            Your resume has been uploaded
          </span>
          <button type="button" className="btn-primary-outlined-xs uppercase" onClick={() => setResumeUrl(undefined)}>Clear resume</button>
        </div>
      );
    }

    return (
      <div>
        {title && <div className="mb-3">{title}</div>}
        <FileUploadDragDrop
          onUpload={saveResume}
          uploadFn={resumeUploadFn(API)}
          accept={{ 'application/pdf': ['.pdf'] }}
          folder=""
          text={text}
          miniMode={miniMode}
        />
      </div>

    );
  };

  return (
    <div className="w-full">
      {renderResume()}
    </div>
  );
};
